
export const jobQueueRequest = [{
  compilers: {id: true},
  controlServer: {id: true},
  simulators: {id: true}
}];
